"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaAvailablePeriodsCalculator = void 0;
const lodash_1 = require("lodash");
// SchedulingFormulaを計算して、availablePeriodsを返す計算機クラス
class FormulaAvailablePeriodsCalculator {
    /**
     * 2次元の配列の各要素に対してAND演算を実行してeachFormulaAvailablePeriodsを計算
     * 　　[['wombat', 'kazuya'], ['coara', 'rika']]
     *    ↓ AND演算
     *    {
     *      'wombat&kazuya': wombat&kazuyaのPeriods,
     *      'coara&rika': coara&rikaのPeriods
     *    }
     *
     * @param formulaParam 式
     * @param userAvailablePeriods 式に含まれる各ユーザーのAvailablePeriods
     * @returns
     */
    static calc(formulaParams, userAvailablePeriods) {
        if ((0, lodash_1.isUndefined)(formulaParams)) {
            return {};
        }
        // 式をDecode
        const eachFormulaAvailablePeriods = formulaParams.reduce((acc, singleFormula) => {
            const andCalculateResult = this.calcSingleFormula(userAvailablePeriods, singleFormula);
            if ((0, lodash_1.isNull)(andCalculateResult))
                return acc;
            // ['kazuya', 'wombat'] => 'kazuya&wombat'のようにキーに戻す
            const key = singleFormula.join('&');
            // eachFormulaAvailablePeriods['kazuya&wombat'] = andCalculateResultとして結果をセット
            acc[key] = andCalculateResult;
            return acc;
        }, {});
        // NOTE: タイミングによっては空オブジェクトになるため、その場合は空
        if ((0, lodash_1.isEmpty)(eachFormulaAvailablePeriods)) {
            return {};
        }
        return eachFormulaAvailablePeriods;
    }
    /**
     * 単一の式のavailablePeriodsを計算する
     * @param userAvailablePeriods
     * @param singleFormula
     * @returns
     */
    static calcSingleFormula(userAvailablePeriods, singleFormula) {
        // 式のAND演算
        const userPeriodsArray = (0, lodash_1.compact)(singleFormula.map((p) => userAvailablePeriods[p]));
        // userAvailablePeriodsが見つからない場合空配列になる
        if ((0, lodash_1.isEmpty)(userPeriodsArray)) {
            return null;
        }
        return userPeriodsArray.reduce((acc, currentValue) => acc.and(currentValue));
    }
}
exports.FormulaAvailablePeriodsCalculator = FormulaAvailablePeriodsCalculator;
//# sourceMappingURL=formulaAvailablePeriodsCalculator.js.map